import { render, staticRenderFns } from "./YCusContentDialog.vue?vue&type=template&id=0b479bfe&scoped=true"
import script from "./YCusContentDialog.vue?vue&type=script&lang=js"
export * from "./YCusContentDialog.vue?vue&type=script&lang=js"
import style0 from "./YCusContentDialog.vue?vue&type=style&index=0&id=0b479bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b479bfe",
  null
  
)

export default component.exports